'use client';

import { createContext } from 'react';

export const DesitnationCollection = createContext(null);

export function DesitnationCollectionProvider({ value, children }) {
  return <DesitnationCollection.Provider value={value}>{children}</DesitnationCollection.Provider>;
}
